import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import allAPI from '../../api/api';

// Initial state for tickets
const initialState = {
    tickets: [],
    ticketDetail: {},
    status: 'idle',
    error: null,
};

// Async thunk for creating a ticket
export const createTicket = createAsyncThunk('tickets/createTicket', async (payload) => {
    try {
        const response = await allAPI.tickets.createTicket(payload);
        if (response.status === 200) {
            return response.data;
        } else {
            throw new Error(`Unexpected status code: ${response.status}`);
        }
    } catch (error) {
        console.error('API call failed:', error);
        throw error;
    }
});

// Async thunk for fetching all tickets
export const getAllTickets = createAsyncThunk('tickets/getAllTickets', async (payload) => {
    try {
        const response = await allAPI.tickets.getAllTickets(payload);
        if (response.status === 200) {
            return response.data;
        } else {
            throw new Error(`Unexpected status code: ${response.status}`);
        }
    } catch (error) {
        console.error('API call failed:', error);
        throw error;
    }
});

// Async thunk for fetching a single ticket by ID
export const getTicketById = createAsyncThunk('tickets/getTicketById', async (id) => {
    try {
        const response = await allAPI.tickets.getTicketById(id);
        if (response.status === 200) {
            return response.data;
        } else {
            throw new Error(`Unexpected status code: ${response.status}`);
        }
    } catch (error) {
        console.error('API call failed:', error);
        throw error;
    }
});

// Tickets slice
const ticketsSlice = createSlice({
    name: 'tickets',
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(createTicket.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(createTicket.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.tickets.push(action.payload);  // Add new ticket to the list
            })
            .addCase(createTicket.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            });

        // Handle getAllTickets
        builder
            .addCase(getAllTickets.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getAllTickets.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.tickets = action.payload;  // Replace tickets with fetched data
            })
            .addCase(getAllTickets.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            });

        // Handle getTicketById
        builder
            .addCase(getTicketById.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getTicketById.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.ticketDetail = action.payload;  // Set the details of the fetched ticket
            })
            .addCase(getTicketById.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            });
    }
});

// Export default reducer
export default ticketsSlice.reducer;
